import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { contextCompanySelector } from '../../../../redux/context/company/selectors'

const GroupGuard: React.FC = () => {
  const company = useSelector(contextCompanySelector)

  if (company && !company.groupId) {
    return <Navigate to="/settings/company/company-info/general" replace />
  }

  return <Outlet />
}

export default GroupGuard
